// actions/employee-onboarding/list.js

import { attachAuth } from '../../utils/authService';

// list

export function listHasErrored(bool) {
  return {
    type: 'ONBOARDING_LIST_HAS_ERRORED',
    hasErrored: bool
  };
}

export function listIsLoading(bool) {
  return {
    type: 'ONBOARDING_LIST_IS_LOADING',
    isLoading: bool
  };
}

export function listFetchDataSuccess(list) {
  return {
    type: 'ONBOARDING_LIST_FETCH_DATA_SUCCESS',
    list
  };
}

export function listFetchData(host, params) {
  return (dispatch) => {
    dispatch(listIsLoading(true));
    dispatch(listHasErrored(false));
    fetch(host + 'admin/list?search=' + params.search + '&door=' + params.door, {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(listFetchDataSuccess(result));
            dispatch(listHasErrored(false));
            dispatch(listIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(listHasErrored(true));
            dispatch(listIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(listHasErrored(true));
      dispatch(listIsLoading(false));
    });
  };
}

// listGroups

export function listGroupsHasErrored(bool) {
  return {
    type: 'ONBOARDING_LIST_GROUPS_HAS_ERRORED',
    hasErrored: bool
  };
}

export function listGroupsIsLoading(bool) {
  return {
    type: 'ONBOARDING_LIST_GROUPS_IS_LOADING',
    isLoading: bool
  };
}

export function listGroupsFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_LIST_GROUPS_FETCH_DATA_SUCCESS',
    data
  };
}

export function listGroupsFetchData(host, params) {
  return (dispatch) => {
    dispatch(listGroupsIsLoading(true));
    dispatch(listGroupsHasErrored(false));
    fetch(host + 'admin/listGroups', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(listGroupsFetchDataSuccess(result));
            dispatch(listGroupsHasErrored(false));
            dispatch(listGroupsIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(listGroupsHasErrored(true));
            dispatch(listGroupsIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(listGroupsHasErrored(true));
      dispatch(listGroupsIsLoading(false));
    });
  };
}